import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const GuestOrderLookup = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const [orderId, setOrderId] = useState("");
  const [phone, setPhone] = useState("");
  const [msg, setMsg] = useState("");
  const [checkingLogin, setCheckingLogin] = useState(true);

  useEffect(() => {
    setMsg(searchParams.get("msg") || "");
  }, [searchParams]);

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const res = await axios.get("/api/auth/me", {
          withCredentials: true,
        });

        if (res.data && (res.data.user_id || res.data.is_login === true)) {
          window.location.href = "/mypage";
          return;
        }
      } catch (e) {
        // 비로그인 상태면 그대로 진행
      } finally {
        setCheckingLogin(false);
      }
    };

    checkLogin();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const cleanOrderId = String(orderId || "").trim();
    const cleanPhone = String(phone || "").trim();

    if (!cleanOrderId || !cleanPhone) {
      setMsg("주문번호/휴대폰을 입력해 주세요.");
      return;
    }

    navigate(
      `/kiosk/guest-order-detail?order_id=${encodeURIComponent(
        cleanOrderId
      )}&phone=${encodeURIComponent(cleanPhone)}`
    );
  };

  if (checkingLogin) {
    return (
      <>
        <style>{`
          body { background:#f6f7f9; }
          .card { border:0; border-radius:14px; }
        `}</style>
        <div className="container py-4">
          <div className="card p-3">확인 중...</div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{`
        body { background:#f6f7f9; }
        .card { border:0; border-radius:14px; }
      `}</style>

      <div className="container py-4">
        <div className="card p-3">
          <h4 className="fw-bold mb-2">비회원 주문조회</h4>
          <div className="text-muted small mb-3">
            주문번호와 주문자 휴대폰 번호로 조회합니다.
          </div>

          {msg ? (
            <div className="alert alert-danger py-2">{msg}</div>
          ) : null}

          <form onSubmit={handleSubmit} className="d-grid gap-2">
            <div>
              <label className="form-label fw-bold">주문번호</label>
              <input
                type="number"
                name="order_id"
                className="form-control"
                placeholder="예) 1234"
                required
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
              />
              <div className="form-text">
                결제 성공 화면에서 보이는 주문번호(숫자) 입력
              </div>
            </div>

            <div>
              <label className="form-label fw-bold">휴대폰 번호</label>
              <input
                type="text"
                name="phone"
                className="form-control"
                placeholder="01012345678"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <div className="form-text">하이픈 없이 입력</div>
            </div>

            <button type="submit" className="btn btn-primary w-100 py-3 fw-bold mt-3">
              주문 조회
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default GuestOrderLookup;